export default "__VITE_ASSET__9ed0075e__"